import React, { useEffect, useState, useRef } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table, Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import { COLOR_APP, DEFAULT_SUMMARY_MESSAGE } from '../../../constants'
import moment from "moment";
import { convertOrderStatus } from "../../../helpers/orderStatus";
import { thousandSeperate } from "../../../helpers";
import { GET_ORDERS } from "../../../graphql/order/query";
import { useLazyQuery, useMutation } from "@apollo/client";

import { UPDATE_ORDER } from "../../../graphql/order/mutation";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import WhatsappIcon from "../../../components/WhatsappIcon";
import { GET_POST_STOCKS } from "../../../graphql/liveStock/query";
import LiveDetailMessenger from "./LiveDetailMessenger";
import PaginationsV1 from "../../../components/PaginationV1";

function LiveDetailCF({ peopleOrders, liveData, totalOrder, page, rowsPerPage, pageAll, handleChangePage }) {
    const { history } = useReactRouter()

    const [liveOrderList, setLiveOrderList] = useState([]);
    const [liveTotalOrderList, setLiveTotalOrderList] = useState([]);
    const [liveStockList, setLiveStockList] = useState([]);
    const [liveProductSummary, setLiveProductSummary] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [orderToPrint, setOrderToPrint] = useState([])
    const [isSelectAll, setIsSelectAll] = useState(false)
    const [selectedUser, setSelectedUser] = useState();
    const [showUserModal, setShowUserModal] = useState(false)
    const [showMessengerModal, setShowMessengerModal] = useState(false)
    const [userPhone, setUserPhone] = useState("85620")
    const [message, setMessage] = useState(DEFAULT_SUMMARY_MESSAGE);
    const [shopSettings, setShopSettings] = useState([]);

    const [updateOrder] = useMutation(UPDATE_ORDER);
    const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        // if (liveData) getLiveOrder()
        initSetting()
    }, [liveData])

    useEffect(() => {
        if (peopleOrders) editPostDetailList(peopleOrders);
    }, [peopleOrders])

    useEffect(() => {
        if (shopSettingData && shopSettingData?.settings?.data?.length > 0) {
            setShopSettings(shopSettingData?.settings?.data[0])
        }
    }, [shopSettingData])

    const editPostDetailList = (orderDataGroupList) => {
        let _newPeopleOrders = orderDataGroupList.map((people) => {
            return {
                cfName: people[0]?.cfName,
                totalPrice: people?.reduce((sumPrice, order) => {
                    return sumPrice + (order?.amount * order?.price)
                }, 0),
                totalCount: people?.reduce((sumAmount, order) => {
                    return sumAmount + order?.amount
                }, 0),
                stockMessages: people?.map((message) => { return message?.cfMessage }).join(', '),
                createdAt: people[0]?.createdAt,
                status: people[0]?.status,
                // orders: value,
                pageName: liveData?.pageName,
                pageId: liveData?.pageId,
                phone: people[0]?.phone
            }
        });
        setLiveTotalOrderList(_newPeopleOrders)
    }

    const initSetting = async () => {
        setIsLoading(true)
        let SHOP_ID = await localStorage.getItem("SHOP");
        await getSettings({
            variables: {
                where: {
                    shop: SHOP_ID
                },
                orderBy: "createdAt_ASC"
            }
        })
        setIsLoading(false)
    }

    const modifyData = async () => {
        const result = _.groupBy(liveOrderList, 'liveStock.id')

        let _liveProductSummary = []
        for (let [key, value] of Object.entries(result)) {
            let _mapStock = liveStockList.filter((lStock) => lStock.id == value[0]?.liveStock?.id)
            let pushData = {
                ..._mapStock[0],
                count: value.length,
                cfMessage: value[0]?.liveStock?.cfMessage
            }
            _liveProductSummary.push(pushData)
        }
        setLiveProductSummary(_liveProductSummary)
        setIsLoading(false)
    }


    const goToUserOrder = async (data) => {
        history.push('/post-user-detail', data)
    }

    const onSeletedAllOrder = async () => {
        if (isSelectAll) {
            setOrderToPrint([])
            setIsSelectAll(false)
        } else {
            setOrderToPrint(liveTotalOrderList)
            setIsSelectAll(true)
        }
    }

    const onSelectOrder = (data) => {
        var _newOrderToPrint = orderToPrint;
        // console.log('data: ', data)

        if (orderToPrint.length <= 0) {
            return _newOrderToPrint.push(data);
        }
        orderToPrint.map((order) => {
            // console.log('order: ', data)
            if (order.cfName === data.cfName) {
                return _newOrderToPrint.pop({ cfName: order.cfName });
            }
            return _newOrderToPrint.push(data);
        });
        // console.log('_newOrderToPrint: ', _newOrderToPrint)
        setOrderToPrint(_newOrderToPrint)
    }

    const _selectListLiveWithStatus = async (value) => {
        try {
            if (value) {
                await getOrderData({
                    variables: {
                        where: {
                            cfName: value,
                            live: liveData?.id,
                            isDeleted: false
                        },
                        skip: 0,
                        limit: 3000
                    }
                })
            } else {
                await getOrderData({
                    variables: {
                        where: {
                            live: liveData?.id,
                            isDeleted: false
                        },
                        skip: 0,
                        limit: 3000
                    }
                })
            }

        } catch (error) {
            console.log("Error retrieving posts", error);
        }
    }


    const _updateUserPhone = async (_selectedUser) => {
        try {

            let _afterUpdate = await updateOrder({
                variables: {
                    where: {
                        id: _selectedUser?.orders[0]?.id
                    },
                    data: {
                        phone: userPhone
                    }
                }
            })
            console.log("OK!")
            let cfText
            let total = 0
            selectedUser.orders.map((cf, index) => {
                cfText = (cfText ? cfText : "") + (index + 1) + " : " + cf.productName + " ( x" + cf.amount + " ) :  " + new Intl.NumberFormat('en-US').format(cf.totalPrice ?? cf.price) + ` ກີບ \n`
                total = total + (cf.totalPrice ?? cf.price)
            })
            let settingMessage = message;
            var _variableList = settingMessage.match(/\{\{.+?\}\}/g)
            let _bankData = (shopSettings && shopSettings.bank) ? JSON.parse(shopSettings.bank) : ""
            if (_variableList && _variableList.length > 0) _variableList.map((x, index) => {
                if (x.includes("cfText")) settingMessage = settingMessage.replace(x, cfText);
                if (x.includes("total")) settingMessage = settingMessage.replace(x, new Intl.NumberFormat('en-US').format(total));
                if (x.includes("bankName")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankName) ? _bankData.bankName : "");
                if (x.includes("bankAccount")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankAccount) ? _bankData.bankAccount : "");
                if (x.includes("bankUser")) settingMessage = settingMessage.replace(x, (_bankData && _bankData.bankUser) ? _bankData.bankUser : "");
            })

            let _userPhone = userPhone
            setUserPhone("")
            setShowUserModal(false)
            console.log(`https://wa.me/${_userPhone}?text=${settingMessage}`)
            window.open(`https://wa.me/${_userPhone}?text=${settingMessage}`)

        } catch (err) {
            setShowUserModal(false)
        }


    }

    return (
        <div>
            <div style={{ height: 10 }} />

            <div style={{ height: 10 }} />
           <Table responsive className="staff-table-list borderless table-hover">
                <thead style={{ background: "#F1F1F1" }}>
                    <tr style={{ whiteSpace: 'nowrap' }}>
                        <th style={{ borderBottom: "none" }}>ລຳດັບ</th>
                        <th style={{ borderBottom: "none" }}>ລູກຄ້າ</th>
                        <th style={{ borderBottom: "none" }}>ຈຳນວນ</th>
                        <th style={{ borderBottom: "none" }}>ລະຫັດສິນຄ້າ</th>
                        <th style={{ borderBottom: "none" }}>ລວມເງິນ</th>
                        <th style={{ borderBottom: "none" }}>ວັນທີ,ເດືອນ,ປີ</th>
                    </tr>
                </thead>
                <tbody>
                    {liveTotalOrderList?.map((order, index) => (
                        <tr key={index} onClick={() => {
                            setSelectedUser(order)
                        }}>
                            <td>{page * rowsPerPage + index + 1}</td>
                            <td>{order?.cfName}</td>
                            <td>{thousandSeperate(order?.totalCount ?? 1)}</td>
                            <td style={{ wordBreak: "break-word", width: 230 }}>{order?.stockMessages}</td>
                            <td>{thousandSeperate(order?.totalPrice ?? 0)}</td>
                            <td>{moment(order?.createdAt).format('HH:mm DD/MM/YYYY')}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>  

            <PaginationsV1
                count={totalOrder}
                rowsPerPage={rowsPerPage}
                page={page}
                pageAll={pageAll}
                onPageChange={handleChangePage}
            />

            <Modal show={showMessengerModal} onHide={() => setShowMessengerModal(false)}>
                <Modal.Header closeButton>
                    <div style={{ textAlign: "center" }}>
                        <div>ຕິດຕໍ່ຫາລູກຄ້າຜ່ານທ່າງ Facebook Messenger </div>
                        <div style={{ color: "red" }}></div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <LiveDetailMessenger selectedUserOrder={selectedUser} closeMessengerModal={() => setShowMessengerModal(false)} />
                </Modal.Body>
            </Modal>

        </div >
    );
}

export default LiveDetailCF;